<template>
  <div>
    <div
      v-if="!datasReady"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <div
      v-else
      class="notice-table-list"
    >
      <a-table
        :columns="columns"
        :data-source="currentData"
        :expanded-row-keys="expands"
        class="table-list"
        :row-class-name="rowItem"
      >
        <div
          slot="template"
          slot-scope="template"
          class="edit-template"
        >
          <a-tooltip
            placement="top"
            trigger="hover"
            overlay-class-name="notice-teplate-tooltip"
          >
            <template
              slot="title"
            >
              <span v-html="template" />
            </template>
            <span v-html="template" />
          </a-tooltip>
        </div>
        <div
          slot="selectedreceive"
          slot-scope="selectedreceive"
          class="receive-p-list"
        >
          <a-tag
            v-for="(item, index) in selectedreceive"
            :key="index"
          >
            {{ getMembers(item) }}
          </a-tag>
        </div>
        <div
          v-if="tabName !=='system'"
          slot="sendperiodname"
          slot-scope="sendperiodname, record"
        >
          <span>{{ record.sendperiodname }}</span>
        </div>
        <div
          slot="auditstatus"
          slot-scope="auditstatus, record"
        >
          <div class="op-tool-box">
            <span
              v-if="record.auditstatus === 0"
              class="audit"
            >{{ $t('message["1049"]') }}
              <a-tooltip placement="right">
                <template slot="title">
                  <div
                    slot="content"
                    class="audit-tip-box"
                  >
                    {{ getType(record.class) }}{{ auditTipTxt[0] }}{{ getType(record.class) }}{{ auditTipTxt[1] }}
                  </div>
                </template>
                <!-- <a-button class="tip-btn"><i class="icon iconfont icon-tip-notice-normal-gr tip-icon" /></a-button> -->
                <i class="icon iconfont icon-tip-notice-normal-gr tip-icon iconicon-test31" />
              </a-tooltip>
            </span>
            <a
              v-else
              href="javascript:;"
              @click="editMsg(record)"
            >{{ $t('message["36"]') }}</a>
          </div>
        </div>
      </a-table>
      <edit-dialog
        :datas="itemData"
        :visible.sync="showEditDialog"
      />
    </div>
  </div>
</template>
<script>
import { getMembers, getType } from '@/store/config/scripts.js'
// import ItemEdit from './ItemEdit'
import EditDialog from './EditDialog'
import { mapState, mapMutations, mapGetters } from 'vuex'
export default {
  components: {
    EditDialog
  },
  data () {
    return {
      expandedRowKeys: [],
      itemData: {},
      showEditDialog: false
    }
  },
  computed: {
    ...mapState('config/notice', ['tabName', 'expands', 'datasReady']),
    ...mapGetters('config/notice', ['currentData']),
    columns () {
      if (this.tabName === 'system') {
        return this.columnsSystem
      } else if (this.tabName === 'sms') {
        return this.columnsSms
      } else {
        return this.columns1
      }
    },
    columns1 () {
      const columns1 = [{
        dataIndex: 'noticetype',
        key: 'noticetype',
        title: this.$t('message["1217"]')
      }, {
        title: this.$t('message["651"]'),
        dataIndex: 'title',
        key: 'title'
      }, {
        title: this.$t('message["652"]'),
        dataIndex: 'template',
        key: 'template',
        scopedSlots: { customRender: 'template' }
      }, {
        title: this.$t('message["510"]'),
        key: 'selectedreceive',
        dataIndex: 'selectedreceive',
        scopedSlots: { customRender: 'selectedreceive' }
      }, {
        title: this.$t('message["1072"]'),
        key: 'sendperiodname',
        dadaIndex: 'sendperiodname',
        scopedSlots: { customRender: 'sendperiodname' }
      }, {
        title: this.$t('message["79"]'),
        key: 'auditstatus',
        dadaIndex: 'auditstatus',
        scopedSlots: { customRender: 'auditstatus' }
      }]
      return columns1
    },
    columnsSms () {
      const columnsSms = [{
        dataIndex: 'noticetype',
        key: 'noticetype',
        title: this.$t('message["1217"]')
      }, {
        title: this.$t('message["652"]'),
        dataIndex: 'template',
        key: 'template',
        scopedSlots: { customRender: 'template' }
      }, {
        title: this.$t('message["510"]'),
        key: 'selectedreceive',
        dataIndex: 'selectedreceive',
        scopedSlots: { customRender: 'selectedreceive' }
      }, {
        title: this.$t('message["1072"]'),
        key: 'sendperiodname',
        dadaIndex: 'sendperiodname',
        scopedSlots: { customRender: 'sendperiodname' }
      }, {
        title: this.$t('message["79"]'),
        key: 'auditstatus',
        dadaIndex: 'auditstatus',
        scopedSlots: { customRender: 'auditstatus' }
      }]
      return columnsSms
    },
    columnsSystem () {
      const columnsSystem = [{
        dataIndex: 'noticetype',
        key: 'noticetype',
        title: this.$t('message["1217"]')
      }, {
        title: this.$t('message["651"]'),
        dataIndex: 'title',
        key: 'title'
      }, {
        title: this.$t('message["652"]'),
        dataIndex: 'template',
        key: 'template',
        scopedSlots: { customRender: 'template' }
      }, {
        title: this.$t('message["510"]'),
        key: 'selectedreceive',
        dataIndex: 'selectedreceive',
        scopedSlots: { customRender: 'selectedreceive' }
      }, {
        title: this.$t('message["79"]'),
        key: 'auditstatus',
        dadaIndex: 'auditstatus',
        scopedSlots: { customRender: 'auditstatus' }
      }]
      return columnsSystem
    },
    auditTipTxt () {
      return this.$t('message["653"]').split('|')
    }
  },
  methods: {
    getMembers,
    getType,
    ...mapMutations('config/notice', ['changeExpands']),
    editMsg (item) {
      this.expandedRowKeys.push(item.id)
      this.changeExpands(this.expandedRowKeys)
      this.itemData = item
      this.showEditDialog = true
    },
    rowItem () {
      return 'rowItem'
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-template {
  width: 220px;
  height: 42px;
  overflow: hidden;
}
.receive-p-list {
  width: 180px;
}
.audit {
  .iconicon-test31 {
    color: #ccc;
    font-style: normal;
    vertical-align: middle;
  }
}

</style>
<style lang="scss">
.notice-teplate-tooltip {
  .ant-tooltip-arrow {
    display: none;
  }
}
</style>
